import Text from '@deprecated-ui/common/Text';
import numeral from 'numeral';
import { getColorBasedOnNumber } from 'utils/general';
import { formatNumber } from 'utils/number';

interface Props {
  total: number;
  percentage: number;
  isLoss?: boolean;
}

export default function Realized({
  total = 0,
  percentage = 0,
  isLoss = false,
}: Props) {
  return (
    <Text color={getColorBasedOnNumber(total)} family="bold">
      <span>
        {isLoss ? '' : '+'}
        {formatNumber(total, false, '0,00', true)}
      </span>
      &nbsp;
      <span>
        ({isLoss ? '-' : '+'}
        {numeral(percentage * 100).format('0,00.00', Math.floor)}%)
      </span>
    </Text>
  );
}
